import ImageModel from './src/ImageModel.vue'

ImageModel.install = function(Vue) {
    Vue.component(ImageModel.name, ImageModel)
}

export default ImageModel